module.exports = __webpack_public_path__ + "img/watch-calculator.40f93326.svg";